import Portfolio from 'actions/portfolio';

export default Portfolio.createReducer();